<template>
  <div>
    <b-card title=" " no-body>
      <b-card-header>
        <b-col cols="12" class="mt-2">
          <h4>Top 10 Sparepart</h4>
        </b-col>
      </b-card-header>

      <b-card-body>
        <!-- Date Picker -->
        <!-- <b-row>
          <b-col md="6">
            <date-picker 
            v-model="dateRange" 
            :use12h="true" 
            type="date"
            :show-second="false" 
            range 
            placeholder="Select Date Range" />
          </b-col>
          <b-col md="6">
            <b-button variant="primary" @click="fetchTop10Items">Filter</b-button>
          </b-col>
        </b-row> -->

        <!-- Table -->
        <b-table :items="items" :fields="fields" striped show-empty hover style="margin-top: 20px;">
          <template v-slot:cell(rank)="data">
            <b-badge variant="info">{{ data.item.rank }}</b-badge>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: {
    "date-picker": DatePicker,
  },
  data() {
    return {
      dateRange: null,
      fields: [
        { key: "rank", label: "#" },
        { key: "itemModel", label: "Item Model" },
        { key: "description", label : "Description"},
        { key: "productHierarchy", label : "Product Hierarchy"},
        { key: "count", label: "Total Sold" },
      ],
    };
  },
  mounted() {
    this.getTop10Item({
      start_date: this.dateRange ? this.dateRange[0] : null,
      end_date: this.dateRange ? this.dateRange[1] : null,
    })
  },
  computed: {
    ...mapGetters({
      items: 'inventory/filteredTop10Items',
    }),
    top10Items() {
      return this.filteredTop10Items;
    },
    dateRangeUTC() {
    if (!this.dateRange || this.dateRange.length < 2) return null;

    return [
      new Date(this.dateRange[0]).toISOString(),
      new Date(this.dateRange[1]).toISOString()
    ];
  }
  },
  methods: {
    ...mapActions({
      getTop10Item: 'inventory/getTop10Items'
    }),

    fetchTop10Items(){
      console.log("this.dateRange", this.dateRange);
      
      console.log("start", new Date(this.dateRange[0]));
      
      this.getTop10Item({
        start_date:  this.dateRange ? new Date(this.dateRange[0]) : null,
        end_date: this.dateRange ? new Date(this.dateRange[1]) : null,
      })
    }
  },
  created() {
    document.title = 'Top 10 Item | RSP'
  },
};
</script>

<style scoped>
</style>
